import PropTypes from 'prop-types';

const AnyChildren = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.node),
  PropTypes.node,
  PropTypes.func,
]);

export default AnyChildren;
